import * as Yup from 'yup'
import i18n from '../../../../../../translations/i18n'

export const AdjustmentModalSchema = Yup.object().shape({
    action: Yup.string().required(),
    to: Yup.string().required(),
    photographer: Yup.object().when(['to'], {
        is: fromTo => fromTo === 'freelancer',
        then: Yup.object().required().nullable()
    }),
    reason: Yup.string().when('action', {
        is: 'send_money',
        then: Yup.string().required()
    }),
    amount: Yup.number()
        .positive()
        .integer(i18n.t('errors:number_invalid'))
        .typeError(i18n.t('errors:number_invalid'))
        .required(),
    custom_airbnb_id: Yup.bool(),
    airbnb_user_id: Yup.string().when('custom_airbnb_id', {
        is: custom_airbnb_id => custom_airbnb_id,
        then: Yup.string().required('errors:required')
    }),
    notes: Yup.string().required()
})
